<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="editDetailId == undefined" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="true">

      <template v-slot:list :pk="pk">
        <DxDataGrid class="pt-2" ref="datagrid" :data-source="rows" :show-borders="true" :show-row-lines="true"
          :show-column-lines="true" :hover-state-enabled="true" :height="contentHeight" key-expr="Id"
          parent-id-expr="ParentDetailId" :auto-expand-all="true" :word-wrap-enabled="true" row-alternation-enabled
          @option-changed="onOptionChanged" :selected-row-keys="[editDetailId]" :on-content-ready="onContentReady">
          <DxToolbar>
            <DxItem location="before">
              <template #default>
                <v-checkbox v-model="groupByCustomer" label="Group by Customer" dense hide-details
                  class="mt-0 pt-0 pl-2" />
              </template>
            </DxItem>
            <DxItem location="before">
              <template #default>
                <v-checkbox v-model="showTerminated" label="Show Terminated" dense hide-details class="mt-0 pt-0 pl-2"
                  @click="fetchRows" />
              </template>
            </DxItem>
            <DxItem name="searchPanel" location="after" class="pr-2" />
          </DxToolbar>
          <DxLoadPanel :enabled="loading" />
          <DxHeaderFilter :visible="showHeaderFilter" />
          <DxSearchPanel :visible="true" :width="240" placeholder="Search..." />
          <DxPaging :page-size="1000" />
          <DxGrouping :auto-expand-all="true" />
          <DxGroupPanel :visible="false" />
          <DxColumn v-if="groupByCustomer" :group-index="0" data-field="__customerDisplayText" :caption="'Customer'" />
          <DxColumn data-field="__detailText" caption="Produkttekst" :min-width="300" width="35%"
            cell-template="detailTextTemplate" />
          <!--
            <DxColumn data-field="ContractDetailComment" caption="Kommentar" :min-width="90"
            cell-template="commentTemplate" />
            -->
          <DxColumn data-field="__NextInvoiceStartDateDisplay" caption="Neste" :min-width="90" width="90" />
          <DxColumn data-field="__NextInvoiceEndDateDisplay" caption="Til" :min-width="90" width="90" />
          <!--
          <DxColumn data-field="__ContractTerminatedDateDisplay" caption="Terminert" :min-width="90" />
          -->
          <DxColumn data-field="__ContractStartDisplay" caption="Start" :min-width="90" :width="90" />
          <DxColumn data-field="__ContractEndDisplay" caption="Slutt" :min-width="90" :width="90" />
          <DxColumn data-field="Qty" caption="Antall" :min-width="35" alignment="right" />
          <DxColumn data-field="__unitPrice" caption="Stykkpris" alignment="right" cell-template="unitPriceTemplate" />
          <DxColumn data-field="__monthlyPriceDisplay" caption="Pris pr måned" alignment="right"
            cell-template="monthlyPriceTemplate" />
          <DxColumn data-field="__yearlyPriceDisplay" caption="Pris pr år" alignment="right" :min-width="75" />
          <DxColumn caption="" :width="49" :fixed="true" fixed-position="right" alignment="center"
            cell-template="actionButtonTemplate" />
          <DxSummary :recalculate-while-editing="true">
            <DxTotalItem column="__detailText" summary-type="sum" display-format="{0}"
              :customize-text="customizeSummaryText" />
          </DxSummary>

          <template #detailTextTemplate="{ data }">
            <div :class="subContractDetailClass(data.data)">
              <div :class="[terminatedClass(data.data), 'link']"
                style="cursor: pointer;" @click="openItem(data.data)">
                {{ data.value }}
                <v-tooltip v-if="data.data.InvoiceComment" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small class="ml-1" v-bind="attrs" v-on="on">mdi-note-outline</v-icon>
                  </template>
                  <span>{{ data.data.InvoiceComment }}</span>
                </v-tooltip>
              </div>
              <span> {{ data.data.ContractDetailComment }}</span>
            </div>
          </template>

          <template #commentTemplate="{ data }">
            <div :class="['ellipsis', terminatedClass(data.data)]">
              {{ data.data.ContractDetailComment || data.data.InvoiceComment || data.data.ContractDetailArticleSalesText
                || '' }}
            </div>
          </template>

          <template #unitPriceTemplate="{ data }">
            <template v-if="data.data.PriceModelId == 2">
              {{ data.data.__unitPriceDisplay }}
            </template>
            <template v-else>
              <span v-if="data.data.__yearlyPriceDisplay">{{ data.data.__yearlyPriceDisplay }} /år</span>
            </template>
          </template>

          <template #monthlyPriceTemplate="{ data }">
            <template v-if="data.data.PriceModelId == 1">
              {{ data.value }}
            </template>
          </template>

          <template #actionButtonTemplate="{ data }">
            <v-btn v-if="data.data.Id != editDetailId" x-small icon @click.stop="openItem(data.data)">
              <v-icon size="20">mdi-pencil</v-icon>
            </v-btn>
            <v-btn v-else x-small icon @click.stop="closePreview()">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </template>
        </DxDataGrid>
      </template>

      <template v-slot:preview>
        <EditPane :id="editDetailId" ref="editPane" :contract="contract" :closePreview="closePreview"
          @AddChildRequested="openNewDialogForParent" @DetailDeleted="onDetailDeleted" @OnUpdate="onUpdate">
        </EditPane>
      </template>
    </Layout>

    <NewContractDetailDialog :externaltrigger="dialogTrigger" :externalCloseTrigger="dialogCloseTrigger"
      :contract="contract" :parentDetail="newChildParentDetail" @Added="onDraftAdded"
      @RequestClose="handleDialogClosed">
    </NewContractDetailDialog>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import Layout from "@/views/layouts/PreviewableList.vue";
import EditPane from "./EditContractDetailPane.vue";
import DxDataGrid, { DxColumn, DxGrouping, DxGroupPanel, DxHeaderFilter, DxPaging, DxSearchPanel, DxSummary, DxTotalItem, DxToolbar, DxItem, DxLoadPanel } from 'devextreme-vue/data-grid';
import NewContractDetailDialog from "@/components/Dialogs/NewContractDetailDialog.vue";
import ContractMixin from "@/helpers/Mixins/ContractMixin";
import SettingsConstants from "@/helpers/Constants/SettingsConstants";
import SettingsMixin from '@/views/admin/settings/default-settings/SettingsMixin';

const contractSettingList = [
  SettingsConstants.ContractArticles,
  SettingsConstants.ContractAutomaticOrders,
  SettingsConstants.ContractAutomaticOrdersStartPaymentDaysOffset,
  SettingsConstants.ContractBatchOrders,
  SettingsConstants.ContractCreditOrderTextPrefix,
  SettingsConstants.ContractCustomerTextArticle,
  SettingsConstants.ContractDefaultInvoiceLengthMonths,
  SettingsConstants.ContractDefaultLengthMonths,
  SettingsConstants.ContractDocumentTemplateIds,
  SettingsConstants.ContractMachineTextArticle,
  SettingsConstants.ContractPeriodTextArticle,
  SettingsConstants.ShowNewContractViews,
  SettingsConstants.UpdateContractPaymentPlan,
];

export default {
  name: "AdminContractDetailList",
  props: {
    lockedFilters: Object,
    contract: Object,
  },
  components: {
    DxPaging,
    Layout,
    EditPane,
    DxDataGrid,
    DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxSummary,
    DxTotalItem,
    DxHeaderFilter,
    DxSearchPanel,
    DxToolbar,
    DxItem,
    DxLoadPanel,
    NewContractDetailDialog,
  },
  mixins: [clientAPI, FilterQueryMixin, ContractMixin, SettingsMixin],

  data() {
    return {
      showHeaderFilter: false,
      groupByCustomer: true,
      showTerminated: false,
      pk: "ACDL-",
      rows: [],
      loading: true,
      isLoading: false,
      createLoading: false,
      initiated: false,
      dialogTrigger: 1,
      dialogCloseTrigger: 1,
      newChildParentDetail: null,

      settingList: contractSettingList,
    };
  },

  mounted() {
    console.log("AdminContractDetailList mounted");
    this.fetchSettings();
    this.fetchRows();
  },

  methods: {
    onContentReady() {
      this.$nextTick(() => {
        this.$refs.datagrid.instance.updateDimensions();
      });
    },
    onOptionChanged(e) {
      // Automatically disable grouping when user sorts by clicking a column
      if (e.name === 'columns' && e.fullName.includes('.sortOrder')) {
        if (this.groupByCustomer) {
          this.groupByCustomer = false;
        }
      }
    },
    onUpdate(detail) {
      const updated = this.prepareRow(detail);
      const existing = this.findRowById(updated.Id);
      if (existing) {
        Object.assign(existing, updated);
      }
      // Refresh the DataGrid to recalculate totals
      if (this.$refs.datagrid && this.$refs.datagrid.instance) {
        this.$refs.datagrid.instance.refresh();
      }
    },
    subContractDetailClass(row) {
      return row.ParentDetailId != null ? 'pl-4' : '';
    },
    terminatedClass(row) {
      return row.ContractTerminatedDate && new Date(row.ContractTerminatedDate) < new Date() ? 'contract-terminated' : '';
    },
    fetchSettings() {
      var groups = new Set(this.settingList.map(obj => obj.group));
      this.isLoading = true;

      clientAPI.methods.getSettingsListByGroup({ groups: [...groups] }).then(response => {
        //map the setting values from the reponse onto the setting list items
        this.settingList.forEach(setting => {
          var newVal = response[setting.group?.toLowerCase()][setting.settingKey];
          this.settingValueFromString(setting, newVal)
        });
        //also re-fetch globalsettings in the background if necessary
        if (this.settingList.some(x => x.globalSettingsKey)) {
          this.$store.dispatch("getUserInfo", true);
        }
        this.isLoading = false;
        this.initiated = true;
      });
    },

    async fetchRows() {
      //console.log("Fetching contract detail list with filters:", this.combinedFilters);
      this.loading = true;
      try {
        const filter = this.combinedFilters;
        const response = await this.getContractDetailsWithLatestPriceFromFilter(filter);
        const list = response?.Content ?? response?.content ?? [];
        this.rows = this.flattenTree(list)
          .filter(item => this.showTerminated || !item.ContractTerminatedDate || new Date(item.ContractTerminatedDate) > new Date())
          .map(item => this.prepareRow(item));
      } finally {
        this.loading = false;
      }
    },

    flattenTree(items) {
      const result = [];
      const flatten = (item) => {
        const children = item.SubContractDetails;
        const flat = { ...item };
        delete flat.SubContractDetails;
        result.push(flat);
        if (Array.isArray(children) && children.length > 0) {
          children.forEach(child => {
            child.ParentDetailId = item.Id;
            child.Customer = item.Machine?.Customer || item.Customer; // inherit customer for grouping
            child.CustomerId = item.Machine?.Customer?.Id || item.CustomerId;
            child.InvoiceCustomer = item.InvoiceCustomer; // inherit invoice customer for grouping
            child.InvoiceCustomerId = item.InvoiceCustomerId;
            flatten(child);
          });
        }
      };
      items.forEach(item => flatten(item));
      return result;
    },

    onDraftAdded(created) {
      if (created) {
        const prepared = this.prepareRow(created);
        this.rows.unshift(prepared);

        // If the edit pane is open on this parent, inject the new child into it via ref
        if (prepared.ParentDetailId && String(prepared.ParentDetailId) === String(this.editDetailId) && this.$refs.editPane) {
          this.$refs.editPane.insertChildDetail(created);
        }

        // Clear child-parent selection and close dialog
        this.newChildParentDetail = null;
      }
    },

    handleDialogClosed() {
      this.newChildParentDetail = null;
      this.dialogCloseTrigger++;
    },

    onDetailDeleted({ id }) {
      if (!id) return;
      this.removeRowById(id);
    },

    openNewDialogForParent(parentDetail) {
      this.newChildParentDetail = parentDetail;
      this.dialogTrigger++;
    },

    findRowById(id) {
      return this.rows.find(x => x && x.Id === id);
    },

    removeRowById(id) {
      const idx = this.rows.findIndex(x => x && x.Id === id);
      if (idx >= 0) {
        this.rows.splice(idx, 1);
      }
    },

    formatMoney(v) {
      if (v == null || isNaN(v)) return '';
      try {
        return Number(v).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      } catch { return v; }
    },

    prepareRow(detail) {
      // Shallow copy to avoid mutating original reference
      const row = { ...detail };

      // Detail text
      row.__detailText = this.getDetailText(row);
      row.__customerId = detail.CustomerId || detail.Machine?.Customer?.Id || detail?.InvoiceCustomerId || this.contract?.CustomerId;
      row.__customerName = detail.Customer?.Name || detail.Machine?.Customer?.Name || detail.InvoiceCustomer?.Name || this.contract?.Customer?.Name;
      row.__customerDisplayText = `${row.__customerId} ${row.__customerName}`;
      // Dates (preformatted display strings)
      row.__NextInvoiceStartDateDisplay = this.i18nFormatDate(row.NextInvoiceStartDate);
      row.__NextInvoiceEndDateDisplay = this.i18nFormatDate(row.NextInvoiceEndDate);
      row.__ContractTerminatedDateDisplay = this.i18nFormatDate(row.ContractTerminatedDate);
      row.__ContractStartDisplay = this.i18nFormatDate(row.ContractStart);
      row.__ContractEndDisplay = this.i18nFormatDate(row.ContractEnd);

      // Prices
      let monthly = null;
      let unit = null;
      let yearly = null;

      const qty = row.Qty != null ? Number(row.Qty) : null;
      if (row.PriceModelId == 1) {
        monthly = this.monthlyPrice(row) * qty;
        yearly = monthly != null ? monthly * 12 : null;
      } else if (row.PriceModelId == 2) {
        unit = this.unitPrice(row);
        yearly = unit != null && qty != null ? unit * qty : null;
      }

      row.__monthlyPrice = monthly;
      row.__unitPrice = unit;
      row.__yearlyPrice = yearly;

      row.__monthlyPriceDisplay = monthly != null ? this.formatMoney(monthly) : '';
      row.__unitPriceDisplay = unit != null ? this.formatMoney(unit) : '';
      row.__yearlyPriceDisplay = yearly != null ? this.formatMoney(yearly) : '';

      // Children (tree rows): prepare recursively so nested rows have precomputed fields
      if (Array.isArray(row.SubContractDetails) && row.SubContractDetails.length) {
        row.SubContractDetails = row.SubContractDetails.map(child => this.prepareRow(child));
      }
      return row;
    },

    monthlyPrice(detail) {
      if (!detail) return null;
      if (detail.PriceModelId != 1) return null; // PerMonth only
      const prices = detail.ContractPrices || [];
      if (!prices.length) return detail.Price ?? null;
      const now = new Date();
      // Do NOT mutate source arrays during render; work on copies only
      const pick = prices
        .map(p => ({ ...p, _d: new Date(p.PriceDate) }))
        .filter(p => !isNaN(p._d))
        .sort((a, b) => b._d - a._d)
        .find(p => p._d <= now) ||
        prices.slice().sort((a, b) => new Date(b.PriceDate) - new Date(a.PriceDate))[0];
      return pick?.NewPrice ?? null;
    },

    unitPrice(detail) {
      if (!detail) return null;
      if (detail.PriceModelId == 2) {
        return detail.Price ?? detail.HighPrice ?? detail.LowPrice ?? null;
      }
      return null;
    },

    yearlyPrice(detail) {
      if (!detail) return null;
      if (detail.PriceModelId == 1) {
        const m = this.monthlyPrice(detail);
        return m != null ? m * 12 : null;
      }
      if (detail.PriceModelId == 2) {
        const u = this.unitPrice(detail);
        const q = detail.Qty != null ? Number(detail.Qty) : null;
        if (u != null && q != null) return u * q;
      }
      return null;
    },

    openItem(item) {
      this.editDetailId = item.Id;
      this.$nextTick(() => {
        this.$refs.datagrid.instance.updateDimensions();
      })
    },

    closePreview() {
      this.editDetailId = undefined;
      this.$nextTick(() => {
        this.$refs.datagrid.instance.updateDimensions();
      })
    },

    openNewDialog() {
      this.dialogTrigger++;
    },

    refresh() { this.fetchRows(); },

    customizeSummaryText() {
      return 'Total Amount Excl Vat: ' + this.formatMoney(this.rows
        .filter(x => x.ContractTerminatedDate == null || new Date(x.ContractTerminatedDate) > new Date())
        .reduce((sum, row) => sum + (row.__yearlyPrice || 0), 0)) + " per year";
    }
  },

  computed: {
    editDetailId: {
      get() {
        return this.$route.query.detailId;
      },
      set(newVal, oldVal) {
        // already open or close
        if (!newVal || (newVal == oldVal)) {
          this.$router.push({ query: { ...this.$route.query, detailId: undefined } });
        }
        else {
          this.$router.push({ query: { ...this.$route.query, detailId: newVal } });
        }
      }
    },

    combinedFilters() {
      const optional = this.filters || {};
      const locked = this.lockedFilters || {};
      return { ...optional, ...locked, ItemsPerPage: 1000 };
    },

    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    externalNewTrigger() {
      return this.$store.state.triggerevents.newTrigger;
    },

    contentHeight() {
      return this.$store.getters['navstore/ContentContainerHeight'];
    },

    settingMap() {
      var obj = {};
      this.section.settingList.forEach(s => {
        obj[s.settingKey] = s;
      });
      return obj;
    },
  },


  watch: {
    //"$route.query.timestamp"() { this.fetchRows(); },
    //lockedFilters: { deep: true, handler() { this.fetchRows(); } },
    contract: { deep: true, handler() { /* update article filter context */ } },

    externalNewTrigger() {
      this.openNewDialog();
    }
  }
};
</script>


<style lang='scss' scoped>
.ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

/* DevExtreme TreeList customization */
::v-deep .dx-treelist {
  font-size: 14px;
}

::v-deep .dx-treelist-rowsview .dx-row {
  cursor: pointer;
}

::v-deep .dx-treelist .dx-row>td {
  padding-top: 4px;
  padding-bottom: 4px;
}

::v-deep .dx-treelist .dx-header-row>td {
  font-weight: 600;
  background-color: #f5f5f5;
}

::v-deep .dx-treelist-text-content {
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .dx-command-expand {
  width: 30px;
}

::v-deep .dx-datagrid-group-space {
  width: 2px !important;
  /* Adjust the value as needed */
  min-width: 2px !important;
}

.contract-terminated {
  text-decoration: line-through;
}

.link:not(.contract-terminated) {
  color: #1976d2;
  font-weight: bold;
}

::v-deep .dx-datagrid-headers {
  height: 30px;
}

::v-deep .dx-header-row>td>.dx-datagrid-text-content {
  white-space: nowrap !important;
  text-overflow: ellipsis;
}

::v-deep .dx-datagrid-headers .dx-datagrid-content {
  height: 30px;
}
</style>